import { makeStyles } from 'e100-react-components';

import { LoadingPlaceholderProps } from './ui';

interface StyleProps extends Pick <LoadingPlaceholderProps, 'width'> {}

export const useStyles = makeStyles(({ spacing, shape, palette }) => ({
  container: ({ width }: StyleProps) => ({
    height: spacing(1.5),
    borderRadius: shape.borderRadius / 2,
    backgroundColor: palette.grey[200],
    width: width ?? '100%'
  })
}));
